import { useToast } from '@chakra-ui/react';
import { useSplunkLogger } from '@resolutionlife/ui';
import { useUnblockUserMutation } from '../../../../graphql/generated';
import { UserUnblockButtonProps } from './user-unblock-button';

export const useUnblockUser = () => {
  const toast = useToast();
  const splunkLogger = useSplunkLogger();
  const [unblockUserMutation, { loading }] = useUnblockUserMutation();

  const unblockUser = async ({
    userId,
    userName,
    startTimedPolling,
  }: UserUnblockButtonProps) => {
    try {
      const { data } = await unblockUserMutation({
        variables: { userId },
      });

      if (data) {
        // Need to poll because Auth0 takes a few seconds to update
        startTimedPolling();

        toast({
          title: `Unblocked ${userName}`,
          status: 'success',
          position: 'top',
        });
      }
    } catch {
      toast({
        title: `Unable to unblock ${userName}`,
        description: `Please try again`,
        status: `error`,
        position: `top`,
      });
      splunkLogger.error('User unblock failed', { eventCategory: 'user_management_error', userId, userName });
    }
  };

  return {
    unblockUser,
    isUnblockLoading: loading,
  };
};
